import React from 'react'
import { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { CustomPagination } from '../../common/table-pagination/CustomPagination';
import ReactBootstrapModal from '../../common/modals/ReactBootstrapModal';
import { MembershipInfo } from '../../common/modals/user-table-info/MembershipInfo';
import { CustomAlert } from '../../common/Alerts/CustomAlert';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import logger from '../../../utils/logger';
import { motion } from 'framer-motion';
import './trainingDataTable.css'
import { Link } from 'react-router-dom';
import { dateFormat } from '../../../helper/dataFormat';
import { phoneNumberFormat } from '../../../helper/phoneNumberFormat'
import { LoadingComponent } from '../../common/LoadingComponent/LoadingComponent'
import { getStateInfo } from '../../../helper/stateTranslate';
import { CircleStatusComponent } from '../../common/CircleStatusSpan/CircleStatusComponent';
import { UseSettingColumns } from '../../../hooks/DataTable-hooks/useVisibleCols';
import { UseVisibleMembership } from '../../../hooks/DataTable-hooks/UseMembershipModal';
import { UseGetMemberById } from '../../../hooks/DataTable-hooks/UseGetMemberById';
import { EmptyDataComponent } from '../../common/EmptyData/EmptyDataComponent';
import { MemberService } from '../../../services/MemberService';
import { TrainingActionOnUser } from './TrainingActionOnUser';
import { CopyButton } from '../../common/modals/user-table-info/modal-sectors/common-components/CopyButton';


export const TpaTrainingTable = ({ actionsPack, memberShip, alert, usersData, handleObject, loading, currentPagination, stateModel, enableMobileLoading, HideReached, onInputCheckBoxPageSize }) => {




    //?Manejo de la Paginacion con la Api
    logger.info('currentPagination: ', currentPagination)
    logger.debug('Training userdata: ', usersData)

    const [customObjet, setCustomObjet] = useState({
        PageSize: currentPagination.PageSize,
        PageIndex: currentPagination.PageIndex
    })

    useEffect(() => {
        setCustomObjet({
            PageSize: currentPagination.PageSize,
            PageIndex: currentPagination.PageIndex
        })
    }, [currentPagination])


    const handleChangePage = (newPage) => {
        console.log('newPage: ', newPage)
        const nuevoObjeto = {
            ...customObjet,
            PageIndex: newPage
        };
        setCustomObjet(nuevoObjeto);
        handleObject(nuevoObjeto)

    }

    logger.info('customObjet: ', customObjet)


    const handleChangeRowsPerPage = (newPageSize) => {
        const totalItems = usersData.totalFiltered || 0
        const globalIndex = (customObjet.PageIndex - 1) * customObjet.PageSize + 1
        const newPage = Math.ceil(globalIndex / newPageSize);

        onInputCheckBoxPageSize(newPageSize)

        const nuevoObjeto = {
            PageSize: newPageSize,
            PageIndex: newPage
        }
        setCustomObjet({
            PageSize: newPageSize,
            PageIndex: newPage
        })
        handleObject(nuevoObjeto)
    }

    //? Obtiene la Informacion de un usuario en especifico para el contenido del Modal MEMBERSHIP
    const { memberDataById, handleMemberId } = UseGetMemberById()

    //? Setea la cantidad de columnas visibles segun el ancho de la pantalla
    const { visibleCols } = UseSettingColumns(5)

    //? Setea la visibilidad del modal con la informacion del usuario segun el punto de quiebre para tablet

    const { enableModal } = UseVisibleMembership()

    //? Setea el tipo de Modal que se visializara ALERT O MEMBERSHIP
    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(null);

    const showBootstrapModal = (id) => {
        setBootstrapModalStatus(id);
    }

    //? Setea el contenido del Modal de Alert 

    const [customAlertContent, setCustomAlertContent] = useState(null)

    const handleAlertContent = (params) => {
        setCustomAlertContent(params)
    }


    //? Accion para cerrar los Modals (ALERT o MEMBERSHIP)

    const closeBootstrapModal = () => {
        setBootstrapModalStatus(null);
    }


    // const [currentPage, setCurrentPage] = useState(null);

    // const handlePageChange = (page) => {

    //     logger.info('page:', page)
    //     setCurrentPage(page);

    // };

    // const [onreached, setOnReached] = useState(second)
    const handleCheckboxChange = (row, checked) => {
        logger.warn('Usuario:', row, 'Checked:', checked);
        logger.warn('estado de reached: ', row.enrollments[0].reached, 'estado a enviar:', !row.enrollments[0].reached)
        logger.warn('enrollmentId: ', row.enrollments[0].id)


        const userChecked = async () => {
            try {
                const changeReachedState = await MemberService.TPATrainingChangeReachedState(row.email, !row.enrollments[0].reached, row.enrollments[0].id)

                if (changeReachedState.status === 200) {
                    handleObject({
                        PageSize: 10,
                        PageIndex: 1,
                        HideReached: HideReached
                    })
                }
            } catch (error) {
                logger.error(error);
                // throw error;
            }
        }

        userChecked()

    };




    const allColumns = [


        {
            name: 'Nombre',
            selector: row => `${row.lastname} ${row.name}`,
            cell: row => (

                //! quitar validacion 'row.name' .Solo de prueba para la ruta DELIVERY
                (row.name &&

                    <CircleStatusComponent
                        isVisible={visibleCols <= 5}
                        lastname={row.lastname}
                        enabled={row.enabled}
                        name={row.name}
                        state={row.enrollments[0]?.state}
                    />
                )

            ),
            //? Método para añadir una clase a la CELDA
            // conditionalCellStyles: [
            //     {
            //         when: (row) => true,
            //         classNames: ['name-cell']
            //     }
            // ],
            width: visibleCols == 1 ? '100%' : '25%'

        },
        {
            name: 'Email',
            //selector: row => row.email,
            cell: row =>(
                 <>
                    <div className=" d-inline-block w-100">
                        {row.email}                    
                    </div>
                    <div>
                        <CopyButton
                            text={row.email}
                        />
                    </div>
                 </>
            ),
            width: '30%'
        },
        {
            name: 'Fecha de Alta',
            selector: row => dateFormat(row.createdDate),
            // sortable: true,
            width: '10%'
        },
        // {
        //     name: 'Fecha de Inicio',
        //     selector: row => row.activeEnrollment?.approvedDate ? dateFormat(row.activeEnrollment?.approvedDate) : '-',
        //     // sortable: true,
        // },
        {
            name: 'Teléfono',
            cell: row => (
                <>
                <Link

                    to={`https://wa.me/${phoneNumberFormat(row.phoneNumber, row.phonePrefix.prefix)}`}
                    target='blank'
                    className=" d-inline-block w-fit-content"
                // style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {phoneNumberFormat(row.phoneNumber, row.phonePrefix.prefix, true)}
                </Link>
                <CopyButton
                        text={phoneNumberFormat(row.phoneNumber, row.phonePrefix.prefix, true).replaceAll(`+${row.phonePrefix.prefix}`,"").replaceAll("-","")}
                    />
                </>
            ),
            width: '20%'
        },
        {
            name: 'Estado',
            // sortable: true,
            //? Realiza un efecto map de estados segun el estado mismo que posea el usuario
            cell: row => (

                // logger.debug('.enrollments[0]?.state: ',row.enrollments[0]?.state)

                <span
                    className={`span-status span-${row.enrollments[0]?.state === "Active" && !row.enabled
                        ? "disabled"
                        : row.enrollments[0]?.state?.toLowerCase()
                        }`}
                >

                    {/* {row.state} */}

                    {stateToTranslate(row.enrollments[0]?.state)}
                </span>


            ),
            sortable: true,

        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="acciones d-flex">

                    <TrainingActionOnUser
                        actionsPack={actionsPack}
                        status={row.enrollments[0]?.state}
                        enabled={row.enabled}
                        row={row}
                        handleModal={showBootstrapModal}
                        alert={alert}
                        handleAlertContent={handleAlertContent}
                    />

                    {/* {renderActionButtons(row.state, row)} */}

                </div>
            ),
        },
        {
            name: 'Contactado', // Sin título
            cell: row => (



                row.enrollments[0]?.state === 'PendingForApproval' && (<input
                    className='w-100'
                    type="checkbox"
                    onChange={e => handleCheckboxChange(row, e.target.checked)}
                    checked={row.enrollments[0].reached ?? false}
                />)


            ),
            ignoreRowClick: true,
            // allowOverflow: true,
            // button: true,
        },
        {
            name: 'Fecha de contacto',
            selector: row => row.reachedDate ? dateFormat(row.reachedDate, true) : '-',
            sortable: true,
        }
    ];

    const columns = allColumns.slice(0, visibleCols); // Seleccionar solo las columnas visibles
    const hiddenColumns = allColumns.slice(visibleCols); // Obtener las columnas ocultas
    const maxHeightScroll = `${window.innerHeight * 0.57}px`;
    logger.info('columns: ', columns, 'hiddenColumns: ', hiddenColumns)

    //? Componente expandible para las filas que muestra las columnas ocultas
    const ExpandedComponent = ({ data }) => (
        <div style={{ padding: '10px', background: '#f9f9f9' }}>
            {hiddenColumns.length === 0 ? (
                <i>No hay más datos ocultos.</i>
            ) : (
                <table>
                    <tbody>
                        {hiddenColumns.map((col, index) => (
                            <tr key={index}>
                                <td style={{ fontWeight: 'bold', paddingRight: 10 }}>{col.name}:</td>
                                <td>
                                    {col.selector
                                        ? col.selector(data)
                                        : col.cell
                                            ? col.cell(data)
                                            : '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {/* Mostrar acciones en la fila expandida */}
            {visibleCols < 7 ? null : <div className="acciones">
                {/* <button className="btn toTooltip" title="Rechazar">
                    <span className="material-icons mI-table">cancel</span>
                </button>
                <button className="btn toTooltip" title="Reenviar">
                    <span className="material-icons mI-table">forward_to_inbox</span>
                </button>
                <a href="#" className="btn btn-user-info" title="Info">
                    <span className="material-icons mI-table">visibility</span>
                </a> */}
            </div>}

        </div>
    );


    //? Traduccion de estados 



    const stateToTranslate = (state) => {
        if (usersData.items) {

            const getState = getStateInfo(stateModel, state)
            logger.info('status translationStatus: ', getState)

            return getState.stateString
        }
    }

    return (



        <motion.div
            className="dataTableStyle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <DataTable
                title="Usuarios"
                columns={columns}
                // data={usersData.items}
                data={usersData.items || []}

                //? propiedad para cuando el array esta vacio 
                noDataComponent={
                    <EmptyDataComponent />
                }
                responsive
                highlightOnHover
                striped
                noHeader
                expandableRows={hiddenColumns.length > 0} // Solo permite expandir si hay columnas ocultas
                expandableRowsComponent={ExpandedComponent} // Componente que se muestra al expandir
                fixedHeader
                fixedHeaderScrollHeight={maxHeightScroll}

                pagination
                paginationServer
                paginationPerPage={customObjet.PageSize}
                paginationTotalRows={usersData.totalFiltered || 0}
                paginationDefaultPage={customObjet.PageIndex}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                paginationComponent={CustomPagination}

                // paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50]}


                customStyles={{
                    cells: {
                        style: {
                            padding: '8px', // Ajustar el padding de las celdas
                        },
                    },
                }}
                conditionalRowStyles={[
                    {
                        when: row => true, // o cualquier condición
                        classNames: ['row-style'],
                    },
                ]}

                //! Hace ferencia a la fila clickeada y muestra por consola los datos, util para obtener el id del usuario
                onRowClicked={(row) => {
                    // logger.info('ID del usuario clickeado:', row.id) // 👈 incluso si no lo mostrás

                    logger.info('ID del usuario clickeado:', row.id)
                    logger.info('row:', row)

                    if (memberShip && enableModal) {
                        logger.info('estado de enableAcction: ', enableModal)
                        showBootstrapModal('info')
                        handleMemberId(row.id)
                    }


                }}

                //! LOADING
                progressPending={loading} // 👉cuando true muestra loader
                // progressComponent={<div>Cargando usuarios...</div>}
                progressComponent={<LoadingComponent />}
                // progressComponent={<SkeletonLoader/>}


                //? Flechas de ordenamiento
                onSort={(column, sortDirection) => {



                    if (column.name === 'Fecha de Alta') {
                        handleObject({
                            PageIndex: 1,
                            PageSize: currentPagination.PageSize,
                            HideReached,
                            SortDir: sortDirection,
                            SortBy: 'createdDate',
                        })
                    }
                    else if (column.name === 'Estado') {
                        handleObject({
                            PageIndex: 1,
                            PageSize: currentPagination.PageSize,
                            HideReached,
                            SortDir: sortDirection,
                            SortBy: 'state',
                        })
                    }

                    logger.debug('Columna:', column.name)
                    logger.debug('Dirección:', sortDirection)
                }}

            />


            <ReactBootstrapModal
                toggleModal={closeBootstrapModal}
                showModal={bootstrapModalStatus}
                modalClass={'modalAlert'}
            >

                {bootstrapModalStatus === 'info' ?
                    <MembershipInfo
                        toggleModal={closeBootstrapModal}
                        modalData={memberDataById.data}
                        stateModel={stateModel}
                    />
                    : bootstrapModalStatus === 'alert' ?
                        <>
                            {customAlertContent ?
                                <CustomAlert
                                    content={customAlertContent}
                                    toggleModal={closeBootstrapModal}
                                    handleObject={handleObject}
                                    customObjet={customObjet}
                                />
                                :
                                null}
                        </>
                        :
                        null
                }


            </ReactBootstrapModal>




        </motion.div>

    );
}
